<template>
  
    <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="emitShowDialog(false)">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Galileo Online</v-toolbar-title>
        </v-toolbar>     
            <v-layout style="height:680px;" row>
            <v-spacer></v-spacer>
            <v-flex xl3 lg3 md3 sm12 xs12 pt-2 style="text-align:center;">
              <v-progress-circular
                v-if="loaderRun"
                :size="50"
                color="primary"
                :indeterminate="loaderRun"
              ></v-progress-circular>              
              <div class="resp-container"> 
                <iframe class="resp-iframe" :src="'/gbqrforwarder/'+searchId +'/' + paymentCode +'/' + merchantCode"></iframe>
              </div>
          </v-flex>
          <v-spacer></v-spacer>
          </v-layout>        
        
    </v-card>

</template>

<script>
import BookingService from '../../services/booking.service';

export default {
  props:["searchId","paymentCode","merchantCode"],
  created(){
    //alert(this.searchId + ':' + this.paymentCode);
    this.startPaymentStatusCheck();
    setTimeout(()=>{this.loaderRun=false;},3000);
  },
  data(){
    return {
      paymentStatus:false,
      waitingStatusCheck:false,
      stopStatusCheck:false,
      loaderRun:true,
      emitters:{
        showDialog:"showDialog"
      }
    }
  },
  methods:{
        emitShowDialog(show){
          this.$emit(this.emitters.showDialog,show);
        },
        getPaymentStatus(){
            BookingService.getPaymentStatus(this.searchId).then(rslt=>{
                this.paymentStatus = rslt.data.paymentStatus;
            });
        },
        startPaymentStatusCheck(){
            setInterval(() => {
                if (this.stopStatusCheck==false && this.waitingStatusCheck==false){
                    this.waitingStatusCheck=true;
                    BookingService.getPaymentStatus(this.searchId).then(rslt=>{
                        this.waitingStatusCheck=false;
                        this.paymentStatus = rslt.data.PaymentStatus;
                        this.stopStatusCheck = this.paymentStatus!="-";
                        if (this.paymentStatus=="SUCCESS"){
                            this.$router.push({name:"BookingInfoAndPaymentResult",params:{sid:this.searchId,pm:0}});
                            this.$router.go();                          
                        }                      
                    });                    
                }
            }, 5000);
        },
  }
}
</script>

<style>
.resp-container {
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
    height: 100%;
}
.resp-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}
</style>